import { useMemo } from "react";
import { SidebarImage } from "./SidebarImage/dynamic";

interface Props {
  images: string[];
  current: string | null;
  setCurrent: (image: string) => void;
  productName: string | null;
}

export const useGetSidebarImages = ({
  images,
  current,
  setCurrent,
  productName,
}: Props): JSX.Element[] | null => {
  return useMemo(() => {
    return images.map((photo, index) => {
      const isCurrent = current === photo;
      const imgAlt = `изображение ${index + 1} - ${productName}`;

      const clickHandler = () => {
        setCurrent(photo);
      };

      return (
        <SidebarImage
          width={80}
          height={80}
          isCurrent={isCurrent}
          key={photo}
          src={photo}
          alt={imgAlt}
          title={imgAlt}
          onClick={clickHandler}
        />
      );
    });
  }, [current, images, productName, setCurrent]);
};
